/* File: savedLoginUsers.js
 * Path: ananunadm/src/helpers/savedLoginUsers.js
 *
 * "Remember this account on this device" for the login screen — Facebook/Instagram-style
 * account picker. Only username + display name + avatar are stored (never a password or
 * token), so clicking a saved account just pre-fills the username; the password is still
 * typed by the user. An account only ever appears here if the user explicitly opted in at
 * login time, so unsaved accounts leave no trace after logout.
 */

const STORAGE_KEY = "apit:auth:savedUsers";
const MAX_SAVED_USERS = 5;

export function getSavedLoginUsers() {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		const parsed = raw ? JSON.parse(raw) : [];
		return Array.isArray(parsed) ? parsed.filter((entry) => entry && entry.username) : [];
	} catch {
		return [];
	}
}

export function saveLoginUser({ tenant, username, displayName, avatarUrl, userId }) {
	if (!username) return getSavedLoginUsers();

	const next = [
		{
			tenant,
			username,
			displayName: displayName || username,
			avatarUrl: avatarUrl || "",
			userId: userId || "",
			savedAt: Date.now()
		},
		...getSavedLoginUsers().filter((entry) => (entry.username !== username || entry.tenant !== tenant))
	].slice(0, MAX_SAVED_USERS);

	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
	} catch {
		// Remembering the account is a convenience, not required — ignore storage failures.
	}

	return next;
}

export function removeSavedLoginUser(username, tenant) {
	const next = getSavedLoginUsers().filter((entry) => (entry.username !== username || entry.tenant !== tenant));
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
	} catch {
		// Ignore storage failures.
	}
	return next;
}
